import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useSubscriptionAccess } from '../context/SubscriptionAccessContext';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute component that checks if the user has a valid subscription
 * before allowing access to the route. If the user does not have a valid
 * subscription, they are redirected to the billing plans page.
 *
 * @param {Object} props - The component props.
 * @param {ReactElement} props.element - The element to render if the user has access.
 * @returns {ReactElement|null} The element to render or null if the user is not authenticated.
 */
const ProtectedRoute = ({ element }) => {
    const { user } = useAuth();
    const { subscriptionData, loading } = useSubscriptionAccess();
    const navigate = useNavigate();

    useEffect(() => {
        if (loading || !user) return;

        if (subscriptionData?.isPaid === 0) {
            navigate('/settings/billing/plans', {
                state: {
                    redirectReason:
                        'Your trial period has expired. Please choose a plan to continue.',
                },
            });
        }
    }, [user, loading, subscriptionData, navigate]);

    return element;
};

export default ProtectedRoute;
